import cx from "classnames";
import React from "react";
import stylesV2 from "components/Button/useButtonTemplate.module.scss";
import stylesV3 from "components/Button/useButtonTemplateV3.module.scss";
import { useLocation } from "react-router-dom";
import { ButtonRole, ButtonSize } from "components/Button/types";
import { Spinner } from "components/Button/Spinner";
import {useSchedulingABVariant} from "../../features/scheduling/utils/useSchedulingABVariant";

const getClassNames = (props: {
  role: ButtonRole;
  size: ButtonSize;
  loading: boolean;

  // this won't set the disabled prop on the button, but will style as if
  // it was disabled, allowing the click event to still trigger.
  renderAsDisabled: boolean;
}) => {
  const { role, size, loading, renderAsDisabled } = props;
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;

  return cx(styles.button, {
    [styles.buttonStandard]: role === ButtonRole.Standard,
    [styles.buttonGhost]: role === ButtonRole.Ghost,
    [styles.buttonLarge]: size === "large",
    [styles.buttonLoading]: loading,
    [styles.disabled]: renderAsDisabled,
  });
};

interface ButtonTemplateProps {
  role: ButtonRole;
  size: ButtonSize;
  loading: boolean;
  text: string;
  renderAsDisabled: boolean;
}

export const useButtonTemplate = (
  props: ButtonTemplateProps
): [JSX.Element, string] => {
  const { role, size, loading, text, renderAsDisabled } = props;

  const classNames = getClassNames({
    role,
    size,
    loading,
    renderAsDisabled,
  });

  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;

  const inner = (
    <>
      {loading && <Spinner className={styles.spinner} />}
      <span className={styles.text}>{text}</span>
    </>
  );

  return [inner, classNames];
};
